export const issueStateTranslations = {
  NEW: 'issues:common.state.new',
  IN_PROGRESS: 'issues:common.state.inProgress',
  RESOLVED: 'issues:common.state.resolved',
  REJECTED: 'issues:common.state.rejected',
} as const;
